import { post } from '@http/request'

export const querySubNoList = params => post('/vip/waybillOrder/querySubNoList  ', params)

